import { createCompNode } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import { FeatureRefs } from '../../cssFeatures.types'
import { Component, InnerElementStyle } from '@wix/thunderbolt-becky-types'

const extractFontFamiliesFromStyles = (styles: { [id: string]: InnerElementStyle }): Array<string> => {
	const fontFamilies: Array<string> = []

	const traverseStyleElement = (styleElement: any): void => {
		if (!styleElement || typeof styleElement !== 'object') {
			return
		}

		for (const [key, value] of Object.entries(styleElement)) {
			if (key === 'family' && typeof value === 'string') {
				fontFamilies.push(value)
			} else {
				traverseStyleElement(value)
			}
		}
	}

	traverseStyleElement(styles)
	return fontFamilies
}

export const innerElementsStyleFontFamilies = {
	predicate: () => true,
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'fontFaces'>) => ({
			innerElementsStyles: refs.innerElementsStyles(component),
		}),
		toViewItem: (__, { innerElementsStyles }) => {
			if (!innerElementsStyles) {
				return EMPTY_ARRAY
			}
			return extractFontFamiliesFromStyles(innerElementsStyles)
		},
	}),
}
